export default "__VITE_ASSET__BmvKFcVD__"